module.exports = __webpack_public_path__ + "img/lot_slogn.46306827.png";